<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="9" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户昵称" :value="2"></el-option>
							<el-option label="用户姓名" :value="3"></el-option>
							<el-option label="账号手机号" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>                
                <el-col :xs="24" :sm="12" :md="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
             </el-row>
        </div>

        <div class="page-btns-box">
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" icon="el-icon-minus" size="small" @click="out('',1)">批量移除白名单</el-button>
			<el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" icon="el-icon-plus" size="small" @click="$refs.addWhitelist.show()">添加白名单用户</el-button>
			<el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="download()" :loading="downLoading">导出白名单</el-button>
			<el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" size="small" @click="$refs.importWhitelist.show()">导入白名单</el-button>
        </div>

        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
				@selection-change="handleSelectionChange"
            >
                <el-table-column type="selection"></el-table-column>
				<el-table-column prop="userId" label="用户ID"></el-table-column>
				<el-table-column prop="userName" label="用户昵称"></el-table-column>
				<el-table-column prop="certName" label="用户姓名"></el-table-column>
				<el-table-column prop="telephone" label="账号手机号"></el-table-column>
                
                <el-table-column fixed="right" label="操作" width="380">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"                            
                            @click="out(scope.row.id,2)"
                            >移除白名单</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <AddWhitelist ref="addWhitelist" :id="id" @update="getDataList()"></AddWhitelist>
        <ImportWhitelist ref="importWhitelist" :id="id"  @update="getDataList()" ></ImportWhitelist>
    </div>
</template>

<script>

import AddWhitelist from './components/add-whitelist';
import ImportWhitelist from './components/import-whitelist';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    searchType:1,
    searchValue:'',	
}
export default {
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
	},
    components:{AddWhitelist,ImportWhitelist},
    data (){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchValue: this.$route.query.searchValue || '',
                searchType:parseInt(this.$route.query.searchType || 1)
            },
            listLoading: true,
			whiteListIds:[],
			downLoading:false
            
        }
    },
    computed:{
       
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList(){
            this.listLoading = true;
            this.$request({
                url: '/shopGoodsWhite/pageList',
                method: 'POST',
                data: {
                	 ...this.params,
                	 goodsId: this.id                   
                 },
            }).then(res => {
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.data = result;
                    this.dataList = result.result || [];
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            }
            this.getDataList();
        },
		//全选、反选
		handleSelectionChange(val) {
			this.whiteListIds = val.map( v => v.id );
		},
        //移出白名单 type== 1 批量移除 type==2 是单个的移除
        out(id,type){
			if( type == 1 && this.whiteListIds.length < 1  ){
				 return this.$message.warning('请选择需要移除的用户');
			}else{
				const _msg = '注意：移除白名单后用户不能购买此商品';
				var _arryids = [];
				if( type == 1 ){
					_arryids = this.whiteListIds
				}else{
					 _arryids.push( id )
				}
				  console.log(_arryids)
				this.$confirm(_msg, '确定要将用户移除白名单吗？', {
				    type: 'warning',
				    center: true,
				    closeOnClickModal: false
				}).then(() => {
				    this.listLoading = true;
				    this.$request({
				        url: '/shopGoodsWhite/remove',
				        method: 'POST',
				        data: {
							goodsId:this.id,
							whiteListIds:_arryids					
						},
				    }).then(res => {
				        const { state, msg } = res.data;
				        if( state == 1 ){
				            this.getDataList();
				        }else{
				            this.$message.error(msg || '请求失败');
				        }
				    }).catch(() => {
				        this.$message.error('请求错误');
				    }).finally(() => {
				        this.listLoading = false;
				    });
				}).catch(() => {})
			}
            
        },
		//导出白名单
		download(){
			var now = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd HH:mm:ss' );			
		   let filePath;
		   this.downLoading = true;
			this.$request({
				url: '/shopGoodsWhite/exportWhiteList',
				method: 'POST',
				data: {
					 ...this.params,
					 goodsId: this.id                   
				 },
			}).then(res => {
				const { state, msg, result } = res.data;
				if( state == 1 && result ){
					filePath = result.url;					
					downloadFileTmp(filePath,`${now}_${this.id}_白名单.`+this.$utils.getFileType(filePath));
					this.downLoading = false;
				}else{
					this.downLoading = false;
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {
				this.listLoading = false;
			});
					
		},
    }
}
</script>